export type SpeedUnit = "knots" | "kilometersPerHour" | "milesPerHour";

export type DistanceUnit =
    "meters" | "yards" | "nauticalMiles" | "kilometers" | "miles";

const SPEED_UNIT_ABBREVIATION: Record<SpeedUnit, string> = {
    knots: "kn",
    kilometersPerHour: "km/h",
    milesPerHour: "mph",
};

const DISTANCE_UNIT_ABBREVIATION: Record<DistanceUnit, string> = {
    meters: "m",
    yards: "yd",
    nauticalMiles: "nm",
    kilometers: "km",
    miles: "mi",
};

export function convertSpeed(metresPerSecond: number, unit: SpeedUnit): number {
    switch (unit) {
        case "knots":
            return metresPerSecond * 1.94384;
        case "kilometersPerHour":
            return metresPerSecond * 3.6;
        case "milesPerHour":
            return metresPerSecond * 2.23694;
    }
}

export function convertDistance(metres: number, unit: DistanceUnit): number {
    switch (unit) {
        case "meters":
            return metres;
        case "yards":
            return metres * 1.09361;
        case "nauticalMiles":
            return metres / 1852;
        case "kilometers":
            return metres / 1000;
        case "miles":
            return metres / 1609.34;
    }
}

export function formatSpeed(metresPerSecond: number, unit: SpeedUnit): string {
    return `${convertSpeed(metresPerSecond, unit).toFixed(1)} ${SPEED_UNIT_ABBREVIATION[unit]}`;
}

export function formatDistance(metres: number, unit: DistanceUnit): string {
    return `${convertDistance(metres, unit).toFixed(1)} ${DISTANCE_UNIT_ABBREVIATION[unit]}`;
}
